import React from 'react';

const SG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_46"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_46)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V9H0V0Z"
        fill="#EF2F41"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.863C5.71 7.953 5.4 8 5.077 8C3.377 8 2 6.657 2 5C2 3.343 3.378 2 5.077 2C5.399 2 5.709 2.048 6 2.137C4.752 2.52 3.846 3.657 3.846 5C3.846 6.343 4.752 7.48 6 7.863ZM8 3H9V4H8V3ZM10 4H11V5H10V4ZM9 6H10V7H9V6ZM6 4H7V5H6V4ZM7 6H8V7H7V6Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SG;
